import React from 'react';

/**
 * Renders the module list skeleton experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.count - count numeric value.
 * @param {*} props.media - media value.
 * @param {*} props.variant - variant value.
 * @returns {JSX.Element} The rendered interface.
 */
export default function ModuleListSkeleton({ count = 6, media = true, variant = '' }) {
  return (
    <div className={`module-list-skeleton ${variant ? `module-list-skeleton--${variant}` : ''}`} aria-hidden="true">
      {Array.from({ length: count }).map((_, index) => (
        <article className="module-list-skeleton-card" key={index}>
          {media && <span className="module-list-skeleton-thumb" />}
          <span className="module-list-skeleton-copy">
            <i className="wide" />
            <i className="medium" />
            <i className="short" />
          </span>
        </article>
      ))}
    </div>
  );
}
